import React from 'react';
import MainContent from './layout/MainContent';
import AudienceList from './audiences/AudienceList';
import { ICON_NEW } from './extras/icons';
import AuthoritiesService from '../services/AuthoritiesService';
import { SOLICITUDES_CREAR } from '../data/objects';
import { useSelector } from 'react-redux';
//Función principal
const Audiences = () => {
    //Tomo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Nodos
    const nodes = [];
    //Acciones
    const actions = [
        {
            title: 'NUEVO',
            css: 'success',
            icon: <ICON_NEW className="fa-sm text-white-50" />,
            link: '/audiencias/nueva-solicitud',
            granted: authorities && AuthoritiesService.hasPermission(authorities, SOLICITUDES_CREAR)
        }
    ];
    //Renderizo
    return (
        <MainContent 
            title='Audiencias' 
            subtitle='Listado' 
            nodes={nodes}
            actions={actions}
            component={AudienceList} />
    );
};

export default Audiences;